<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row">
						<div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
							<img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
						</div>
						<div
							ref="stepone"
							id="reset-step-one"
							class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
						>
							<div class="p-8">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4">Actualizar Contraseña</h4>
									<p>Ingresa tu correo electrónico para configurar tu nueva contraseña.</p>
								</div>
								<vs-input
									v-validate="'required|email|min:3'"
									type="email"
									name="email"
									label-placeholder="Correo Electrónico"
									v-model="email"
									class="w-full mb-6"
								/>
								<span v-show="errors.has('email')" class="text-danger text-sm">
									{{ $t("Login.ValidMessages.Email") }}</span
								>
								<div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
									<vs-button
										type="border"
										to="/pages/login"
										class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
										>Volver</vs-button
									>
									<vs-button class="w-full sm:w-auto" @click="getCode()" :disabled="!validateForm">{{
										$t("Submit")
									}}</vs-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import Api from "@/helpers/api";
import ManageErrorMessages from "@/models/ManageErrorMessages.js";

export default {
	data() {
		return {
			email: "",
			password: "",
			code: "",
			meetPasswordStandard: true,
			steps: {
				one: true,
				two: false,
			},
			disabledReset: true,
			keyType: "password",
			keyIcon: "icon-eye",
			manageErrorMessages: new ManageErrorMessages({
				notify: this.$vs.notify,
				that: this,
			}),
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email !== "";
		},
	},
	watch: {
		password(newval, oldval) {
			if (newval.length > 0) {
				this.validatePasswod(newval);
			} else {
				this.meetPasswordStandard = true;
				this.disabledReset = true;
			}
		},
	},
	methods: {
		validatePasswod(password) {
			const reg = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
			this.meetPasswordStandard = reg.test(password);
			if (this.meetPasswordStandard) {
				this.disabledReset = false;
			}
		},
		getCode() {
			let params = {
				email: this.email,
			};

			this.$vs.loading({
				container: "#reset-step-one",
				scale: 0.6,
			});

			Api.post("/recovery/code", params)
				.then((result) => {
					this.steps.one = false;
					this.steps.two = true;
					this.email = "";
					this.$vs.loading.close("#reset-step-one > .con-vs-loading");
					this.$router.push({name: "page-reset-password"});
				})
				.catch((error) => {
					console.error(error);
					this.$vs.loading.close("#reset-step-one > .con-vs-loading");
					this.manageErrorMessages.setErrorMessage(error.data.reason);
					this.manageErrorMessages.showMessage();
				});
		},
		resetPassword() {
			let params = {
				code_recover_pass: this.code,
				new_password: this.password,
			};
			Api.post("/recover/password", params)
				.then((result) => {
					this.code = "";
					this.password = "";
					this.steps.one = false;
					this.steps.two = true;
					this.$vs.loading.close("#reset-step-two > .con-vs-loading");
					this.$vs.notify({
						title: "Felicidades",
						text: "Contraseña configurada con éxito",
						color: "success",
					});
					this.$router.push({name: "page-login"});
				})
				.catch((error) => {
					console.error(error);
					switch (error.data.reason) {
						case "Code recover pass not exists.":
							this.$vs.notify({
								title: "Código Incorrecto",
								text: "Por favor verifica el código.",
								color: "danger",
							});
							break;

						case "The password is not secure.":
							this.$vs.notify({
								title: "Código Incorrecto",
								text: "Tu contraseña debe ser de mínimo 8 caracteres y debe tener 1 mayúscula, 1 minúscula, 1 número y un carácteres especial.",
								color: "danger",
							});
							break;

						default:
							this.code = "";
							this.password = "";
							this.$vs.notify({
								title: "Atención",
								text: "El código ha expirado o hubo un error al configurar tu contraseña, intentalo de nuevo.",
								color: "danger",
							});
							this.steps.one = true;
							this.steps.two = false;
							break;
					}
				});
		},
		SeePassword() {
			if (this.keyType === "password") {
				this.keyType = "text";
				this.keyIcon = "icon-eye-off";
			} else {
				this.keyType = "password";
				this.keyIcon = "icon-eye";
			}
		},
	},
};
</script>
<style>
.password-field {
	position: relative;
}

.eye-password {
	position: absolute;
	top: 4px;
	right: 4px;
	background: transparent;
	height: 30px;
	width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
</style>
